import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GatherersHutBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.GATHERERS_HUT;
}

export default GatherersHutBuildingTileEntity;
